"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var profile_exports = {};
__export(profile_exports, {
  getProfile: () => getProfile,
  patchProfile: () => patchProfile
});
module.exports = __toCommonJS(profile_exports);
const getProfile = async (token) => {
  const url = `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/profile`;
  const res = await fetch(url, {
    method: "GET",
    body: void 0,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  if (!res.ok) {
    return null;
  }
  return await res.json();
};
const patchProfile = async (token, data) => {
  const url = `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/profile`;
  const res = await fetch(url, {
    method: "PATCH",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  if (!res.ok) {
    return null;
  }
  return await res.json();
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getProfile,
  patchProfile
});
